import styled from "styled-components"

export const GlobalRow = styled.div`
  display: flex !important;
  flex-direction: row;
  align-content: center;
  vertical-align: center;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 20px;
`

export const Container = styled.div`
  display: flex;
  background: white;
  flex-direction: row;
  box-shadow: 2px 2px 30px #efefef;
  margin: 10px;
  margin-right: 50px;
  margin-top: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 260px;
`
export const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 2;
  @media (max-width: 1100px) {
    display: none;
  }
  @media (min-width: 1500px) {
    flex: 1;
  }
`
export const Icon = styled.img`
  margin-right: 10px;
  height: 16px;
  margin-top: -15px;
  width: auto;
  background-size: contain;
`

export const Text = styled.p`
  font-weight: 500;
  font-size: 13px;
`
export const Price = styled.p`
  font-weight: 500;
  font-size: 13px;

  color: #264a79;
`

export const ImageContainer = styled.div`
  background: red;
  cursor: pointer;
  width: 100%;
  max-width: 180px;
  margin: 5px;
  margin-left: 10px;
  margin-top: 5px;
  background: url(${props => props.img}) center center/cover no-repeat;
  border-radius: 8px;
`

export const MainContainer = styled.div`
  display: flex;
  margin-left: 20px;
  flex-direction: column;
  flex: 4;
  align-content: flex-start;
  flex-shrink: 1;
`

export const EndContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.5;
  padding-right: 20px;
  margin-top: 10px;
  max-width: 200px;
`

export const Title = styled.p`
  cursor: pointer;
  line-height: 1.4;
  color: #001229;
  font-size: 24px;
  font-weight: 600;
`

export const SubTitle = styled.p`
  color: #264a79;
  font-weight: 500;
  margin-top: -15px;
  height: 30px;
  font-size: 13px;
  line-height: 20px;
`

export const Button = styled.button`
  border-radius: 10px;
  padding: 8px;
  margin: 5px;
  margin-right: 25px;
  border-width: 0;
  color: white;
  font-size: 14px;
  font-weight: 600;
  background: #337ab7;
`

export const ButtonOutline = styled(Button)`
  background: white;
  border: 1px solid #337ab7;
  color: #337ab7;
`
